import http from "@/common/http.service";
const ROOT_URL = "autoresponder";
const DELETE_URL = "autoresponder/delete";
const DUPLICATE_URL = "autoresponder/copy";
const GET_CAMPAIGNS_URL = "autoresponder/fetch_campaigns";
const ACTIVATE_URL = "autoresponder/status-change";
const PUPLISH_AUTORESPONDER = "autoresponder/publish";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = {
        items: response.data.listdata.list,
        total: response.data.total,
      };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL, { id: id, status: 8 });
  },
  duplicate(id) {
    return http.post(DUPLICATE_URL, { id: id });
  },

  fetchAllCampaigns(params, cb) {
    return http.post(GET_CAMPAIGNS_URL, params).then(function (response) {
      cb(response.data);
    });
  },

  activate(id) {
    return http.post(ACTIVATE_URL, { id: id, status: 1 });
  },

  deactivate(id) {
    return http.post(ACTIVATE_URL, { id: id, status: 0, removeQ: 1 });
  },

  publishAutoresponder(params) {
    return http.post(PUPLISH_AUTORESPONDER, params);
  },
};
